<template>
  <section
    class="EnjoymentDetail mb-12 lg:mb-24 relative"
    :class="{ EnjoymentDetailAnimated: animate }"
    v-page-theme="{ bg: bg, text: text }"
    ref="el"
  >
    <slot name="default" />
  </section>
</template>
<script>
import { useBreakpoints, breakpointsTailwind } from '@vueuse/core'

export default {
  props: {
    bg: String,
    text: String
  },
  /*
  data() {
    return {
      animate: true
    }
  },
  */
  setup() {
    const breakpoints = useBreakpoints(breakpointsTailwind)

    return {
      animate: breakpoints.greater('lg')
    }
  },
  provide() {
    return {
      animate: this.animate,
      bounding: () => {
        return this.$refs.el.getBoundingClientRect()
      }
    }
  },
  mounted() {
    console.log('EnjoymentDetail - mounted')
  }
}
</script>
<style lang="scss">
.EnjoymentDetailAnimated {
  .ambi-separator {
    display: none;
  }
}
</style>
